<template>
    <section class="translation-top-menu">
        <div>
            <b-nav tabs ref="topMenu">
                <b-nav-item :to="{name: 'translations'}" :active="this.$router.currentRoute.name == 'translations'">Переводы</b-nav-item>
                <b-nav-item :to="{name: 'dictionary'}" :active="this.$router.currentRoute.name == 'dictionary'">Словарь</b-nav-item>
                <b-nav-item :to="{name: 'translationTasks'}" :active="this.$router.currentRoute.name == 'translationTasks'">Задачи</b-nav-item>
            </b-nav>
        </div>
    </section>
</template>

<script>
    export default {
        name: "topMenu"
    }
</script>

<style scoped>
    .translation-top-menu {
        margin-bottom: 20px;
    }
</style>